export const ROUTES = {
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view',
  HOME: '/',
  MAIN: 'main',
  PUBLIC_PAGES: 'public-pages',
  MAIN_ABOUT_SCHOOL: 'about-school',
  MAIN_ADVANTAGES: 'advantages',
  MAIN_REVIEWS: 'reviews',
  MAIN_ABOUT_BANK: 'about-bank',
  MAIN_FAQS: 'faqs',
  MAIN_CONTACT: 'contact',
  SCHOOLS: 'schools',
  SCHOOL_FAQ: 'faq',
  SCHOOL_PROGRAM: 'program',
  SCHOOL_SPEAKERS: 'speakers',
  SCHOOL_ABILITIES: 'abilities',
  PASSWORD_RECOVERY: 'password-recovery',
  SELECTION_PANEL: 'selection-panel',
  ADMISSION_SURVEY: 'admission_survey',
  APPLICATIONS: 'applications',
  TESTING: 'testing',
  ENROLLED: 'enrolled',
  USERS: 'users',
  USERS_ASSIGNMENT: 'users-assignment',
};
